import { z } from 'zod';

export const prepareSystemMailsResponse = z.object({
    position: z.number().nullable(),
    preparedSystemMails: z.array(z.string()),
});

export type PrepareSystemMailsResponse = z.infer<typeof prepareSystemMailsResponse>;
